import styled from 'styled-components';

export const CloseButton = styled.div`
	position: absolute;
	top: 14px;
	right: 14px;

	svg {
		width: 12px;
		height: 12px;
	}
`;
